import React, { useCallback, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import OnboardingActivities from '@/view/pages/Onboarding/OnboardingActivities/OnboardingActivities';
import OnboardingConfirmation from '@/view/pages/Onboarding/OnboardingConfirmation/OnboardingConfirmation';
import OnboardingEntry from '@/view/pages/Onboarding/OnboardingEntry/OnboardingEntry';
import OnboardingSetUp from '@/view/pages/Onboarding/OnboardingSetUp/OnboardingSetUp';

import { useInitializeDatadog } from '../../../../datadog.config';

export const OnboardingRoutes: React.FC = () => {
  const [userEmail, setUserEmail] = useState('');

  const handleUserEmail = useCallback((userEmail: string) => {
    setUserEmail(userEmail);
  }, []);

  useInitializeDatadog({ ratio: 100 });

  return (
    <Routes>
      <Route
        path="/onboarding"
        element={<OnboardingEntry handleUserEmail={handleUserEmail} />}
      />
      <Route path="/onboarding/:emailId" element={<OnboardingActivities />} />
      <Route
        path="/onboarding/:emailId/confirmation"
        element={<OnboardingConfirmation userEmail={userEmail} />}
      />
      <Route
        path="/confirm/:requestId/:requestToken"
        element={<OnboardingSetUp />}
      />

      <Route path="*" element={<Navigate to="/onboarding" />} />
    </Routes>
  );
};
